/* Reveal driver (see the matching CSS block in base.css).
   - img[loading=lazy]: .is-loaded on first load -> blur-up transition.
     Already-cached images are marked with transitions suppressed, so only
     genuinely arriving pixels animate (keeps repeat views snappy).
   - .product-card: .is-inview once on first viewport entry (never re-hides),
     with a small per-batch stagger.
   Progressive enhancement: all hidden states are gated on html.js-reveal +
   prefers-reduced-motion in CSS; without JS nothing is ever hidden. */
(function () {
  if (!document.documentElement.classList.contains('js-reveal')) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function markLoaded(img, instant) {
    if (instant) {
      /* Suppress the blur-up for already-cached images, then RELEASE the
         inline style next frame — left in place it permanently overrides
         every component transition on the element (crossfades went cut-
         instead-of-fade on repeat views). */
      img.style.transition = 'none';
      img.classList.add('is-loaded');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { img.style.transition = ''; });
      });
      return;
    }
    img.classList.add('is-loaded');
  }
  function watchImg(img) {
    if (img.hasAttribute('data-reveal-watched')) return;
    img.setAttribute('data-reveal-watched', '');
    if (reduce || (img.complete && img.naturalWidth)) {
      markLoaded(img, true);
      return;
    }
    img.addEventListener('load', function () { markLoaded(img, false); }, { once: true });
    img.addEventListener('error', function () { markLoaded(img, true); }, { once: true });
  }

  var io = null;
  if (!reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      var batch = 0;
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.style.transitionDelay = Math.min(batch * 45, 180) + 'ms';
        batch++;
        el.classList.add('is-inview');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
  }
  function watchCard(el) {
    if (el.hasAttribute('data-reveal-watched')) return;
    el.setAttribute('data-reveal-watched', '');
    if (io) io.observe(el);
    else el.classList.add('is-inview');
  }

  function scan(root) {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('img[loading="lazy"]').forEach(watchImg);
    root.querySelectorAll('.product-card').forEach(watchCard);
  }
  scan(document);

  /* Section Rendering API swaps (cart drawer et al.) inject fresh nodes. */
  new MutationObserver(function (muts) {
    muts.forEach(function (m) {
      m.addedNodes.forEach(function (n) {
        if (n.nodeType === 1) scan(n);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  /* Insurance for crawler snapshots and stalled loads: whatever is still
     hidden well after window load reveals silently. */
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('img[loading="lazy"]:not(.is-loaded)').forEach(function (img) {
        img.classList.add('is-loaded');
      });
      document.querySelectorAll('.product-card:not(.is-inview)').forEach(function (el) {
        el.classList.add('is-inview');
      });
    }, 6000);
  });
})();
